import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { BiTrackEventType } from '../../types';
import { BiTrackRepository } from '../bi-track-repository';
import type { BiTrackService } from '../bi-track-service';

@injectable()
export class BiTrackServiceImpl implements BiTrackService {
  // eslint-disable-next-line no-useless-constructor
  constructor(@inject(BiTrackRepository) private _biTrackRepository: BiTrackRepository) {}

  biTrack(eventType: string, data: BiTrackEventType) {
    return this._biTrackRepository.biTrack(eventType, data);
  }
}
